import * as React from 'react'
import { View, Text, FlatList } from 'react-native'
import styled from '@theme/styled-components'
import useI18n from '@i18n/useI18n'

interface Props {
  steps: Step[]
  labelColor?: string
}

const Steps = ({ steps, labelColor }: Props) => {
  const findSelectedStep = steps.find((step) => step.isSelected)
  const findSelectedStepIndex = steps.findIndex((step) => step.isSelected)
  const i18n = useI18n()

  if (!findSelectedStep) {
    return null
  }

  return (
    <MainContainer>
      <StepNumberContainer>
        <StepNumber labelColor={labelColor}>
          {i18n.t('components.steps.title', {
            stepNumber: findSelectedStep.stepNumber,
            stepCount: steps.length,
            label: findSelectedStep.label,
          })}
        </StepNumber>
      </StepNumberContainer>

      <FlatList
        data={steps}
        renderItem={({ item, index }) => (
          <StepContainer isSelected={item.isSelected} isBeforeSelectedStep={index < findSelectedStepIndex} />
        )}
        horizontal
      />
    </MainContainer>
  )
}

export default Steps

const MainContainer = styled(View)`
  justify-content: center;
  align-items: center;
`

const StepNumberContainer = styled(View)`
  padding-bottom: 4px;
`

const StepNumber = styled(Text)<{ labelColor?: string }>`
  ${(props) => props.theme.fonts.Caption1};
  color: ${(props) => (!!props.labelColor ? props.labelColor : props.theme.colors.background)};
`

const StepContainer = styled(View)<{ isSelected: boolean; isBeforeSelectedStep: boolean }>`
  width: 50px;
  height: 8px;
  border-radius: 8px;
  margin-right: 8px;
  background-color: ${(props) =>
    props.isSelected || props.isBeforeSelectedStep
      ? props.theme.colors.primaryFocused
      : props.theme.colors.primaryDark};
  ${(props) => props.isBeforeSelectedStep && 'opacity: 0.3;'}
`
